import usePosSettingsHook from "./usePosSettingsHook";
import usePosOrderDeliveryMethod from "../atoms/usePosOrderDeliveryMethodAtom";
import { DeliveryMethods, None } from "../utils/enum";

const useStandardMenuTargetHook = () => {
  const { settings } = usePosSettingsHook();
  const [deliveryMethod] = usePosOrderDeliveryMethod();
  const configuredTarget = settings?.standard_get_menu_target ?? None.NONE;

  return {
    // if standard_get_menu_target is set to None, consider deliveryMethod as the target
    standardMenuTarget:
      configuredTarget === None.NONE
        ? deliveryMethod || DeliveryMethods.POS_ORDER
        : configuredTarget,
    hasStandardMenuTarget: configuredTarget > None.NONE,
  };
};

export default useStandardMenuTargetHook;
